import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { FaTimes, FaExclamationCircle, FaCheckCircle } from 'react-icons/fa';
import { blockUser } from '../../Services/User/Chat';
import { showToast } from '../Toast/toast';
import CustomButton from '../CustomButton';
import './BlockUserModal.css';

const BlockUserModal = ({ show, onHide, userName, userId }) => {
  const [step, setStep] = useState(1); // 1: Confirmation, 2: Success
  const [blocking, setBlocking] = useState(false);

  const handleConfirm = async () => {
    try {
      setBlocking(true);
      const response = await blockUser(userId);
      
      if (response.status) {
        setStep(2);
      } else {
        showToast(response.message || 'Failed to block user', 'error');
      }
    } catch (error) {
      console.error('Error blocking user:', error);
      showToast(error.message || 'Failed to block user', 'error');
    } finally {
      setBlocking(false);
    }
  };

  const handleCancel = () => {
    setStep(1);
    onHide();
  };

  const handleSuccessClose = () => {
    setStep(1);
    onHide();
  };

  const renderConfirmationStep = () => (
    <div className="block-modal-content">
      <div className="block-icon-wrapper">
        <FaExclamationCircle className="block-icon" />
      </div>
      <h4 className="block-modal-title">Block User</h4>
      <p className="block-modal-question">
        Are you sure you want to block <strong>{userName || 'this user'}</strong>?
      </p>
      <div className="block-modal-buttons">
        <CustomButton
          onClick={handleConfirm}
          disabled={blocking}
          className="block-yes-btn"
        >
          {blocking ? 'Blocking...' : 'Yes'}
        </CustomButton>
        <CustomButton
          onClick={handleCancel}
          variant="secondary"
          className="secondaryButton"
        >
          No
        </CustomButton>
      </div>
    </div>
  );

  const renderSuccessStep = () => (
    <div className="block-modal-content">
      <div className="success-icon-wrapper">
        <FaCheckCircle className="success-icon" />
      </div>
      <h4 className="block-modal-title">Successful</h4>
      <p className="success-message">
        {userName || 'The user'} has been blocked successfully!
      </p>
      <div className="block-form-buttons">
        <CustomButton
          onClick={handleSuccessClose}
          className="block-ok-btn"
        >
          Ok
        </CustomButton>
      </div>
    </div>
  );

  return (
    <Modal show={show} onHide={handleCancel} centered className="block-user-modal">
      <Modal.Body className="block-modal-body">
        <button className="modal-close-btn" onClick={handleCancel}>
          <FaTimes />
        </button>
        
        {step === 1 && renderConfirmationStep()}
        {step === 2 && renderSuccessStep()}
      </Modal.Body>
    </Modal>
  );
};

export default BlockUserModal;

